import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './COMEQ_Token_Ledger_S.css';

const COMEQ_Token_Ledger_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Common Equity Token Token Ledger');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_TOKEN_LEDGER/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/COMEQ_Token_Ledger', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_${i}_SECTION`;
	  const headerId = `#COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_TOKEN_LEDGER/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/COMEQ_Token_Ledger',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/COMEQ_Token_Ledger',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/COMEQ_Token_Ledger_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/COMEQ_Token_Ledger',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/COMEQ_Token_Ledger_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/COMEQ_Token_Ledger_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/COMEQ_Token_Ledger_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/COMEQ_Token_Ledger',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/COMEQ_Token_Ledger',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/COMEQ_Token_Ledger',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/COMEQ_Token_Ledger',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/COMEQ_Token_Ledger',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [COMEQ_TOKEN_LEDGER, setCOMEQ_TOKEN_LEDGER] = React.useState(null);
  const [COMEQ_TOKEN_LEDGER_S, setCOMEQ_TOKEN_LEDGER_S] = React.useState(null);

  var Ids = [];
  for(var Ele in COMEQ_TOKEN_LEDGER_S){
	  for(var Sec in COMEQ_TOKEN_LEDGER_S[Ele]){
			if(Sec == "id")
				Ids.push(COMEQ_TOKEN_LEDGER_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(COMEQ_TOKEN_LEDGER_S[Ele]["status"]);
			else if(Array.isArray(COMEQ_TOKEN_LEDGER_S[Ele][Sec]))
				  for(var Row in COMEQ_TOKEN_LEDGER_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in COMEQ_TOKEN_LEDGER_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_TOKEN_LEDGER`).then((response) => {
      setCOMEQ_TOKEN_LEDGER(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setCOMEQ_TOKEN_LEDGER_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!COMEQ_TOKEN_LEDGER_S) return <div>Loading...</div>;

 const handleLastDataCOMEQ_TOKEN_LEDGER_S = async (data) => {
  };




  const handleAddCOMEQ_TOKEN_LEDGER_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_TOKEN_LEDGER_S', JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/COMEQ_TOKEN_LEDGER_S');
      setCOMEQ_TOKEN_LEDGER_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["1"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_0"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("1","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_0",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["1"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_1"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("1","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_1",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["1"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_2"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("1","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_2",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["1"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_3"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("1","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_3",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["2"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_0"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("2","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_0",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["2"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_1"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("2","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_1",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["2"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_2"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("2","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_2",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["3"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_0"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("3","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_0",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["3"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_1"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("3","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_1",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["4"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_0"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("4","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_0",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["4"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_1"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("4","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_1",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  

const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER));
	Temp_Data["9"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_0"]=value;
	Form_Data_onChange("9","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_0",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER(Temp_Data);
    setCOMEQ_TOKEN_LEDGER(Temp_Data);
	//handleAddCOMEQ_TOKEN_LEDGER(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER']);
  }; 
  

    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["9"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_1"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("9","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_1",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["9"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_2"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("9","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_2",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["9"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_3"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("9","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_3",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  
    
const COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(COMEQ_TOKEN_LEDGER_S));
	Temp_Data["9"]["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_4"]=value;
	//handleAddCOMEQ_TOKEN_LEDGER_S(Temp_Data,App_Data['COMEQ_TOKEN_LEDGER_S']);
	Form_Data_onChange("9","COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_4",value,Temp_Data);
 	//handleLastDataCOMEQ_TOKEN_LEDGER_S(Temp_Data);
    setCOMEQ_TOKEN_LEDGER_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = COMEQ_TOKEN_LEDGER_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Common Equity Token Token Ledger')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`COMEQ Ledger ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_0" type="text" className="form-control" placeholder="COMEQ Ledger ID"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter COMEQ Ledger ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_1" type="text" className="form-control" placeholder="Offering ID"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_2" type="text" className="form-control" placeholder="Investor ID"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Investor ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Class ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_3" type="text" className="form-control" placeholder="Token Class ID"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Token Class ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Balance`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_0" type="text" className="form-control" placeholder="Token Balance"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Token Balance`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Restricted Token Balance`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_1" type="text" className="form-control" placeholder="Restricted Token Balance"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Restricted Token Balance`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Available Token Balance`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_2" type="text" className="form-control" placeholder="Available Token Balance"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Available Token Balance`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Ownership Percentage Total`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_0" type="text" className="form-control" placeholder="Ownership Percentage Total"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Ownership Percentage Total`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Income Allocation Percentage Total`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_1" type="text" className="form-control" placeholder="Income Allocation Percentage Total"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Income Allocation Percentage Total`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '100ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Transfer Agent Record ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_0" type="text" className="form-control" placeholder="Transfer Agent Record ID"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '100ch' }}>
						 {t(`Enter Transfer Agent Record ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Last Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_1" type="text" className="form-control" placeholder="Last Updated At"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Last Updated At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_0"   onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`COMEQ Ledger ID`)}</th>
                        <th>{t(`Offering ID`)}</th>
                        <th>{t(`Investor ID`)}</th>
                        <th>{t(`Token Class ID`)}</th>
                        <th>{t(`Token Balance`)}</th>
                        <th>{t(`Restricted Token Balance`)}</th>
                        <th>{t(`Available Token Balance`)}</th>
                        <th>{t(`Ownership Percentage Total`)}</th>
                        <th>{t(`Income Allocation Percentage Total`)}</th>
                        <th>{t(`Transfer Agent Record ID`)}</th>
                        <th>{t(`Last Updated At`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {COMEQ_TOKEN_LEDGER_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_0"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_1"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_2"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_1_3"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_0"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_1"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_2_2"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_0"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_3_1"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_0"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_4_1"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_0"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_1"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_2"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_3"]} </td>
						<td>{e["COMMON_EQUITY_03_INVESTOR_SUBSCRIPTION_TOKEN_ISSUANCE_COMEQ_TOKEN_LEDGER_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default COMEQ_Token_Ledger_S;  